import viewApi from '@shared/features/views/services/view-api';
import type { TView } from '@shared/types/view';
import type { SortingState, Updater } from '@tanstack/react-table';
import { useState } from 'react';

export const useSorting = (view?: TView) => {
  const [sorting, setSorting] = useState<SortingState>([]);

  const derivedSorting = sorting?.length
    ? sorting
    : view?.visible_static_fields.sorting || [];

  const { mutate: editView } = viewApi.useUpdate();

  function onSortingChange(updaterOrValue: Updater<SortingState>) {
    const sorting =
      typeof updaterOrValue === 'function'
        ? updaterOrValue(derivedSorting)
        : updaterOrValue;

    setSorting(sorting);

    if (!view?.id) return;

    editView({
      id: view?.id,
      visible_static_fields: {
        ...(view?.visible_static_fields || {}),
        sorting,
      },
    });
  }

  return {
    sorting: derivedSorting || [],
    onSortingChange,
  };
};
